<template>
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    viewBox="0 0 200 200" enable-background="new 0 0 200 200" xml:space="preserve">
    <g>
      <path class="color" fill="#F45B5B" d="M154.932,48.262c-6.477-5.355-14.791-8.3-23.411-8.3c-9.957,0-19.598,3.958-26.442,10.873
        c-1.228,1.244-2.383,2.581-3.466,4.033C93.231,43.713,79.227,37.99,65.378,40.521c-11.496,2.086-20.531,8.401-26.843,18.762
        c-8.905,14.624-9.632,28.729-2.152,41.925c3.996,7.059,9.185,13.938,15.857,21.031c12.221,12.993,26.689,25.324,45.531,38.796
        c1.204,0.864,2.495,1.3,3.838,1.3c2.071,0,3.469-1.046,4.163-1.559c17.001-12.141,30.357-23.331,42.034-35.235
        c6.52-6.644,13.918-14.812,19.329-25.011c2.319-4.355,4.961-10.222,4.806-16.92C171.596,69.189,165.874,57.3,154.932,48.262z"/>
    </g>
  </svg>

</template>

<script>
export default {
  name: 'HeartFilledIcon'
}
</script>
